export function extractHeadings(parts) {
  const headings = [];
  parts.forEach((part, partIndex) => {
    const lines = part.content.split('\n');
    lines.forEach(line => {
      const match = line.match(/^(#{1,3})\s+(.+)/);
      if (match) {
        headings.push({
          level: match[1].length,
          text: match[2].trim(),
          partIndex
        });
      }
    });
  });
  return headings;
}

export function countStats(parts) {
  const text = parts.map(p => p.content).join(' ');
  const charCount = text.length;
  const wordCount = text.trim() === '' ? 0 : text.split(/\s+/).filter(Boolean).length;
  const pageCount = Math.max(parts.length > 0 ? 1 : 0, Math.ceil(wordCount / 275));
  const readingTimeMins = Math.ceil(wordCount / 225);

  const formatTime = (mins) => {
    if (mins < 1) return '< 1 min';
    if (mins < 60) return `${mins} min`;
    const hrs = Math.floor(mins / 60);
    const rem = mins % 60;
    return rem > 0 ? `${hrs}h ${rem}m` : `${hrs}h`;
  };

  return {
    chars: charCount.toLocaleString(),
    words: wordCount.toLocaleString(),
    pages: pageCount,
    time: formatTime(readingTimeMins)
  };
}